// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KJxh","productName":"Table_productName__2sK7U"};